import { CompletionsRentalUnitCostBase } from './base/completions-rental-unit-cost-base';

export class CompletionsRentalUnitCost extends CompletionsRentalUnitCostBase { }